import { jsx as f } from "react/jsx-runtime";
import { forwardRef as a, useRef as o, useEffect as d, useImperativeHandle as p } from "react";
/*!
* Copyright (c) 2022 ~ present NAVER Corp.
@billboard.js/react project is licensed under the MIT license

billboard.js, JavaScript chart library
https://naver.github.io/billboard.js/

@version 1.1.1
*/
const b = a((s, i) => {
  const n = o(null), e = o(), { bb: t, options: { ...r }, ...c } = s, u = () => {
    e.current || (r.bindto = n.current, e.current = t.generate(r));
  };
  return d(() => (!t || !r ? console.warn("Required props('bb' or 'options') are not defined.") : u(), () => {
    e.current && (e.current.destroy(), e.current = null);
  }), []), p(
    i,
    () => ({
      get instance() {
        return e.current;
      }
    })
  ), /* @__PURE__ */ f("div", { ref: n, ...c });
});
export {
  b as default
};
